module.exports = __webpack_public_path__ + "static/bg-lottery.c97111d3.png";